<!-- App root section -->
<router-outlet></router-outlet>